<template>
    <div class="jiequ_lei">
        <article class="nav-title" v-show="!this.$flag">
            <mt-header title="更改图片" fixed>
                <a href="javascript:void(0);" slot="left" @click="goBack">
                    <mt-button icon="back"></mt-button>
                </a>
            </mt-header>
        </article>
        <div class="cropperBox_lei">
            <vueCropper style="width:300px;height:300px;display:inline-block;background:white;border:1px solid #acacac" ref="cropper" :img="imgBase64" :outputSize="size" :outputType="outputType" :canScale="options.canScale" :autoCrop="options.autoCrop" :full="options.full"
                :canMove="options.canMove" :centerBox="options.centerBox" :mode="options.mode" :autoCropWidth="options.autoCropWidth" :autoCropHeight="options.autoCropHeight" :fixed="options.fixed" :fixedNumber="options.fixedNumber" :fixedBox="options.fixedBox" :canMoveBox="options.canMoveBox" @cropMoving="cropMoving" @realTime="realTime" width="100%"
                height="100%" ></vueCropper>
        </div>
        <div v-show="isClick" class="wanOk" @click="imageOk">完成</div>
        <div v-show="!isClick" class="wanOking">加载中...</div>
    </div>
</template>
<script>
    import { convertBase64UrlToBlobs } from '../../public/index.js'
    import {
        VueCropper
    } from "vue-cropper";
    export default {
        name: 'cropImage',
        data() {
            return {
                userInfo: null,
                imgBase64: "",
                size: 1, //裁剪生成图片的质量
                outputType: "jpg", //裁剪生成图片的格式
                options: {
                    canScale: false, //图片是否允许滚轮缩放
                    autoCrop: true, //是否默认生成截图框
                    full: true, //是否输出原图比例的截图
                    canMove: true, //上传图片是否可以移动
                    centerBox: true, //截图框是否被限制在图片里面
                    mode: "contain", //图片默认渲染方式
                    // autoCropWidth: 150, //初始化截图框的宽
                    // autoCropHeight: 150, //初始化截图框的高
                    fixed: true,
                    fixedBox:true,
                    infoTrue: false, //截图框資訊
                    canMoveBox:false,
                    fixedNumber: [1, 1]
                },
                corpUrl: "", //所截图的url
                corpBlob: null,
                isMoving:null,
                isClick:true
            }
        },
        mounted() {
             this.imgBase64 = this.$route.query.url
            
        },
       
        methods: {
           goBack(){
                 this.$router.go(-1)
           },
           cropMoving(even) {
                window.removeEventListener("mousemove",this.initSize,false);
                this.isMoving = even.moving;
                // 获取blob
                this.$refs.cropper.getCropBlob(data => {
                    //console.log(data)
                    this.corpBlob = data;
                });
                //获取base64
                this.$refs.cropper.getCropData(data => {
                    // //console.log(data)
                    this.corpUrl = data;
                });
            },
            realTime(even){
                window.addEventListener("mousemove",this.initSize,false)
                this.$refs.cropper.getCropBlob(data => {
                    //console.log(data)
                    this.corpBlob = data;
                });
                //获取base64
                this.$refs.cropper.getCropData(data => {
                    // //console.log(data)
                    this.corpUrl = data;
                });
            },
            async imageOk() {
                 let formData = new FormData();
                this.$refs.cropper.getCropBlob(blob => {
                    // this.corpBlob = blob;
                     formData.append("file", blob, '2222');
                      console.log(formData)
                });
            },
               
        },
        components: {
            VueCropper
        },
    }
</script>
<style lang="scss" scoped>
    .nav-title {
        height: 3rem;
    }
    .wanOk {
        width: 100%;
        height: 3rem;
        background: #C4A57F;
        text-align: center;
        line-height: 3rem;
        color: #fff;
        letter-spacing: 1rem;
    }
    .wanOking{
        width: 100%;
        height: 3rem;
        background: #C4A57F;
        text-align: center;
        line-height: 3rem;
        color: #fff;
    }
</style>





// WEBPACK FOOTER //
// src/components/my/cropImage.vue